// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"121":"19d1600a","224":"fc470fe5","283":"76dbc963","618":"2e1ecc4b","686":"fe9eaa79"}[chunkId] + ".chunk.js";
};